'use-strict';

/* @ngInject */
export default function TableController(
  $scope,
  $location,
) {

  

}
